import { useMemo } from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import {
  GridActionsCellItem,
  GridColDef,
  GridRowParams,
} from '@mui/x-data-grid';
import { DeleteOutline } from '@mui/icons-material';
import { OrganizationContext } from './OrganizationLayout';
import { useConfirmation } from '@/hooks';
import { DataGrid } from '@/components';
import { deleteAccess } from '../slice';

const Access = () => {
  const { currentOrganization } = useOutletContext<OrganizationContext>();

  const { organizationId } = useParams();

  const [renderConfirmationDialog, confirmAccessDeletion] = useConfirmation({
    title: 'Eliminar',
    message: 'Desea eliminar este rol?',
    dispatcher: deleteAccess,
  });

  const columns: GridColDef[] = useMemo(
    () => [
      {
        flex: 2,
        field: 'name',
        headerName: 'User',
        hideSortIcons: true,
        disableColumnMenu: true,
      },
      {
        flex: 2,
        field: 'lastname',
        headerName: 'User',
        hideSortIcons: true,
        disableColumnMenu: true,
      },
      {
        flex: 1,
        field: 'role',
        headerName: 'Rol',
        hideSortIcons: true,
        disableColumnMenu: true,
      },
      {
        type: 'actions',
        field: 'actions',
        headerName: 'Acciones',
        align: 'right',
        headerAlign: 'right',
        hideSortIcons: true,
        disableColumnMenu: true,
        getActions: (params: GridRowParams) => [
          <GridActionsCellItem
            icon={<DeleteOutline />}
            onClick={() => confirmAccessDeletion({
              organizationId,
              uid: params.row.id,
            })}
            label="Eliminar"
          />,
        ],
      },
    ],
    [confirmAccessDeletion, organizationId]
  );

  return (
    <Stack spacing={3}>
      <Stack spacing={3} direction={'row'} alignItems={'center'}>
        <Typography variant="h2">Accesos</Typography>
      </Stack>
      <DataGrid
        rows={Object.values(currentOrganization?.access ?? [])}
        columns={columns}
      />
      {renderConfirmationDialog()}
    </Stack>
  );
};

export default Access;
